module.exports = __webpack_public_path__ + "static/media/wicket-systri-warrick.dd0d0d17.jpg";